module.exports = __webpack_public_path__ + "img/la_base_poulet_petits_pois_Neon_320px.2018599f.jpg";